/* eslint-disable max-depth */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
import React, {useState, useEffect} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Button } from "@cars24/turbo-web/lib/button";
import { STEP_NAMES, LEAD_FORM, ACTIVE_VARIANT_SCREEN, NUMBER, HTTP_CODES, AB_TEST_VARIATIONS } from "../../../constants/app-constants";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import { isValidRegistrationNo } from "../../../utils/helpers/is-valid-registration-no";
import { getDataByKey, REGISTRATION_STEP_NAMES, responseOrder, STEPS_TO_IGNORE, formatInputValue } from "./selector";
import RegCarDetailsPopup from "../reg-car-details-popup";
import ArrowIcon from "../../shared/arrow";
import { sendCustomGaEvents } from "../../../tracking";
import { regNoEntered, repeatInspection } from "./tracking";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import InputRegNo from "../../shared/input-reg-no";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import InputText from "../../shared/input-text";
import emailValidator from "../../../utils/helpers/email-validator";
import { clearItem, getItem, setItem } from "../../../utils/helpers/storage-crud";
import RegNoPrefix from "./images/reg-no-prefix.svg";
import EliteRegNo from "./images/elite-reg-no.svg";

import { Input } from "@cars24/turbo-web/lib/input";
import { ALLIANCE_PAGE_REF_KEY, ALLIANCE_REF_TYPES, SELLER } from "../../../constants/seller-constant";
import { getPlatformHeaders } from "../../../utils/helpers/get-platform-headers";

const TRANSMISSION_TYPE = {
    AT: "Automatic",
    MT: "Manual"
};
const TABS = [
    { name: "Brand", index: 1, key: "brand" },
    { name: "Year", index: 2, key: "year" },
    { name: "Model", index: 3, key: "model" },
    { name: "Variant", index: 4, key: "variant" },
    { name: "States", index: 5, key: "registrationState" }
];

const CarRegistrationNumber = ({
    match,
    isLoggedIn,
    activateFirstStepConnect,
    setShowWidgetConnect,
    registrationInputRef,
    getVehicleDetailConnect,
    setDataConnect,
    fetchYearsBasedOnMakeIdConnect,
    setStepConnect,
    setFuelTypeConnect,
    setTransmissionTypeConnect,
    setVariantActiveScreenConnect,
    setRTOConnect,
    activateLastStepConnect,
    setOwnerNameConnect,
    setAllStepFilledConnect,
    leadData,
    userCarRegistrationNo,
    setUserCarRgistrationNoConnect,
    resetLeadFormDataConnect,
    setFocusBlurRegBoxConnect = () => {},
    setAllDetailFetchedCorrectlyConnect,
    setAnsweredQuestionsConnect,
    setNameConnect,
    disableBtnOnInvalidInput = false,
    disableRouting = false,
    onSuccess = () => {},
    setHypothecationConnect,
    sellerOnFocus = () => {},
    sellerOnBlur = () => {},
    sellerOnClickCta = () => {},
    isRevamped = false,
    ctaText = "Get instant car price",
    leadSource,
    checkForDuplicateAppointmentConnect,
    history,
    setDataFaliureConnect,
    setIsRepeatInspectionConnect,
    isRepeatUser = false,
    isFormVisible = true,
    isDlsCompliant,
    secureToken,
    isElitePage
}) => {
    const {
        isAllStepFill
    } = leadData;

    const isAlliancePage = history.location.pathname.split("/").includes("offer");
    const isAlliancReferraleOfferActive = isAlliancePage && match && match.params && match.params.slug && ALLIANCE_REF_TYPES.includes(match.params.slug);
    const copyOfResponseOrder = [...responseOrder];
    const [formConfig, setFormConfig] = useState(null);
    const [registrationNumber, setRegistrationNumber] = useState(userCarRegistrationNo || "");
    const {stepper, tabs, tabData} = FUNNEL_CONFIG[LEAD_FORM.DEFAULT_REVAMP];
    const isValidRegex = (v) => isValidRegistrationNo(v);
    const [isValidRegistrationNumber, setIsValidRegistrationNumber] = useState(isValidRegex(registrationNumber));
    const [isNotCarReg, setIsNotCarReg] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDuplicateAppointment, setIsDuplicateAppointment] = useState(false);
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (isAlliancReferraleOfferActive && isAlliancePage) {
            const data = getItem(ALLIANCE_PAGE_REF_KEY);
            if (data && emailValidator(data)) setEmail(data);
        }
    }, [isAlliancReferraleOfferActive, isAlliancePage]);

    const handleOnChange = (sanitizedValue) => {
        setIsDuplicateAppointment(false);
        setRegistrationNumber(sanitizedValue);
    };
    // eslint-disable-next-line no-unused-vars

    const registrationNumberValidator = (v) => {
        const isValid = isValidRegex(v.replace(/\s/g, ""));
        setIsNotCarReg(false);
        setIsValidRegistrationNumber(isValid);
        return isValid;
    };

    const onFocusCallback = () => {
        setFocusBlurRegBoxConnect(true);
        sellerOnFocus();
    };

    const onBlurCallBack = () => {
        sellerOnBlur(isValidRegistrationNumber);
        setFocusBlurRegBoxConnect(false);
    };

    const nextStep = (stepName) => {
        activateLastStepConnect(false);
        setStepConnect({ currentStep: stepName, tabs: formConfig.tabs });
        // handleRouting();
    };

    const isValidProperties = (obj) => {

        if (obj) {
            for (const key in obj) {
                if (obj[key] === null || obj[key] === "" || obj[key] === NUMBER.ZERO) {
                    return false;
                }
            }
        } else {
            return false;
        }

        return true;
    };

    useEffect(() => {
        const type = LEAD_FORM.DEFAULT;
        setFormConfig(FUNNEL_CONFIG[type]);
        setAllStepFilledConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isRevamped) {
            setRegistrationNumber("");
        }
    }, [isRevamped]);

    const handleRouting = () => {
        setDataFaliureConnect(true);
        setShowWidgetConnect(false);
        setIsLoading(false);
        if (!disableRouting) resetLeadFormDataConnect(isRepeatUser);
        activateLastStepConnect(false);
        activateFirstStepConnect(false);
    };

    const populateSetData = (stepname, data) => {
        setDataConnect({ type: stepname, data }, { stepper, tabs, tabData });
    };

    const setYearId = async (carDetails) => {
        try {
            const { year, brand, regn_year: regYear } = carDetails;
            const selectedYear = (year && year.year) || regYear;
            const yearList = await fetchYearsBasedOnMakeIdConnect(brand.make_id);
            const yearObj = yearList.filter((data) => data.year === selectedYear);
            const yearId = yearObj && yearObj[0] && yearObj[0].year_id;
            if (yearId) return { ...carDetails, year: {year: selectedYear, year_id: yearId}};
            return carDetails;
        } catch (e) {
            return carDetails;
        }
    };

    const setCarEvaluationSteps = (key) => {
        let stepIndex = TABS.findIndex(tab => (tab.key.toLowerCase() === key));
        if (stepIndex !== -1) {
            if (stepIndex < NUMBER.FOUR) {
                stepIndex += NUMBER.ONE;
            }
            setStepConnect({ currentStep: TABS[stepIndex].key, tabs });

        }

    };

    const closeModal = () => {
        setAllStepFilledConnect(false);
    };

    const submitLead = () => {
        setAllStepFilledConnect(false);
        nextStep(STEP_NAMES.KilometerDriven);
        // handleRouting();
    };

    const breakAdrillaFlow = (response) => {
        setIsLoading(false);
        setShowWidgetConnect(false);
        setAllDetailFetchedCorrectlyConnect(false);
        if (response.rc_vh_class_desc !== "M-Cycle/Scooter(2WN)") {
            // handleRouting(true);
        } else {
            setIsNotCarReg(true);
            setIsValidRegistrationNumber(false);
        }
        return;
    };

    const handleRegNoFlow = async (response, regNumber) => {
        resetLeadFormDataConnect(isRepeatUser);
        let alteredCarDetail = response;
        alteredCarDetail = Object.assign(...copyOfResponseOrder, alteredCarDetail);

        if (alteredCarDetail.ds_details) {
            onSuccess(regNumber);
            setUserCarRgistrationNoConnect(regNumber);

            if (alteredCarDetail && alteredCarDetail.hypothecation !== null) setHypothecationConnect(alteredCarDetail.hypothecation);
            if (alteredCarDetail && alteredCarDetail.rc_owner_name) setNameConnect(alteredCarDetail.rc_owner_name);
            if (alteredCarDetail && alteredCarDetail.rc_owner_sr) {
                setAnsweredQuestionsConnect({
                    key: "owner_number",
                    value: Number(alteredCarDetail.rc_owner_sr) <= NUMBER.THREE ? `${alteredCarDetail.rc_owner_sr}` : "more_than_3"
                });
            }

            const { year: fetchedYear, brand: fetchedBrand, regn_year: regYear } = response;

            if (fetchedBrand && fetchedBrand.make_id && !fetchedYear  && regYear) {
                alteredCarDetail = await setYearId(alteredCarDetail);
            }
            for (const key in alteredCarDetail) {
                if (isValidProperties(alteredCarDetail[key], key)) {
                    if (key === REGISTRATION_STEP_NAMES.BRAND) {
                        populateSetData(STEP_NAMES.Brand, getDataByKey(response, REGISTRATION_STEP_NAMES.BRAND));
                        setCarEvaluationSteps(key);
                    }

                    if (key === REGISTRATION_STEP_NAMES.YEAR) {
                        populateSetData(STEP_NAMES.Year, getDataByKey(alteredCarDetail, REGISTRATION_STEP_NAMES.YEAR));
                        setCarEvaluationSteps(key);
                    }

                    if (key === REGISTRATION_STEP_NAMES.MODEL) {
                        populateSetData(STEP_NAMES.Model, getDataByKey(response, REGISTRATION_STEP_NAMES.MODEL));
                        setCarEvaluationSteps(key);
                    }

                    if (key === REGISTRATION_STEP_NAMES.DS_DETAIL) {
                        const variantResult = alteredCarDetail[key];
                        const defaultVariant = variantResult && variantResult[0];
                        if (variantResult.length > NUMBER.ONE || !defaultVariant.variant) {
                            setFuelTypeConnect("");
                            setTransmissionTypeConnect("");
                            if (response.fuelType) {
                                setFuelTypeConnect(response.fuelType);
                                setVariantActiveScreenConnect(ACTIVE_VARIANT_SCREEN.TRANSMISSIONTYPE);
                            }
                            breakAdrillaFlow(response);
                            return;
                        } else {
                            setFuelTypeConnect(defaultVariant.variant.fuel_type);
                            if (defaultVariant.variant.transmission_type === "AT") {
                                setTransmissionTypeConnect(TRANSMISSION_TYPE.AT);
                            } else {
                                setTransmissionTypeConnect(TRANSMISSION_TYPE.MT);
                            }
                            setVariantActiveScreenConnect(ACTIVE_VARIANT_SCREEN.VARIANT);
                            populateSetData(STEP_NAMES.Variant, getDataByKey(response.ds_details[0], REGISTRATION_STEP_NAMES.VARIANT));
                            setCarEvaluationSteps(STEP_NAMES.State);

                        }
                        if (alteredCarDetail.rc_vh_class_desc === "M-Cycle/Scooter(2WN)") {
                            setIsNotCarReg(true);
                            setIsValidRegistrationNumber(false);
                        } else if (response.states && response.RTO) {
                            setAllStepFilledConnect(true);
                            setShowWidgetConnect(false);
                            setAllDetailFetchedCorrectlyConnect(true);
                            return;
                        }
                        setCarEvaluationSteps(STEP_NAMES.Variant);
                    }

                    if (key === REGISTRATION_STEP_NAMES.STATES) {
                        populateSetData(STEP_NAMES.State, getDataByKey(response, REGISTRATION_STEP_NAMES.STATES));
                    }

                    if (key === REGISTRATION_STEP_NAMES.RTO) {
                        setRTOConnect({ id: alteredCarDetail.RTO.rto_detail_id, displayText: alteredCarDetail.RTO.rto_code });
                        setOwnerNameConnect(alteredCarDetail.rc_owner_name);
                        setIsLoading(false);
                    }

                } else if (!STEPS_TO_IGNORE.includes(key)) {
                    breakAdrillaFlow(response);
                    return;
                }
            }
        } else {
            handleRouting();
        }
        setIsLoading(false);
    };

    const proceedToRegNoFlow = (regNoTrimmed, regNumber) => {
        getVehicleDetailConnect(regNoTrimmed, getPlatformHeaders(SELLER))
            .then((response) => {
                handleRegNoFlow(response, regNumber);
                setIsLoading(false);
            })
            .catch(() => {
                handleRouting();
            });
    };

    const onClickHandler = async () => {
        const isValid = registrationNumberValidator(registrationNumber);
        if (isValid) {
            if (isAlliancReferraleOfferActive && isAlliancePage) {
                if (emailValidator(email)) {
                    setItem(email, ALLIANCE_PAGE_REF_KEY);
                } else {
                    clearItem(ALLIANCE_PAGE_REF_KEY);
                }
            }
            setHypothecationConnect(null);
            sendCustomGaEvents({
                ...regNoEntered,
                eventLabel: registrationNumber,
                ...(leadSource === C2B_LEAD_TYPES.SCRAP_CAR && {eventCategory: "scrap_homepage"})
            });
            sellerOnClickCta(registrationNumber);
            setIsLoading(true);
            setUserCarRgistrationNoConnect(registrationNumber);

            if (isAlliancePage) {
                sendCustomGaEvents({
                    ...regNoEntered,
                    eventCategory: "alliance_homepage",
                    eventLabel: registrationNumber
                });
            }
            const regNoTrimmed = (registrationNumber || "").replace(/\s/g, "");
            checkForDuplicateAppointmentConnect(regNoTrimmed, leadSource, secureToken).then(async (response) => {
                const experimentType = response.userJourneyAbExperiment;
                const isRepeatInspection = response.isRepeatInspection;
                setIsRepeatInspectionConnect(isRepeatInspection);
                if (isRepeatInspection || experimentType === AB_TEST_VARIATIONS.CONTROL) {
                    await yieldToMain();
                    sendCustomGaEvents({
                        ...repeatInspection,
                        eventAction: `repeat_user_${experimentType ? experimentType.toLowerCase() : experimentType}`,
                        eventLabel: `${response.leadToken}`
                    });
                }
                if (isRepeatInspection) {
                    handleRegNoFlow(response, registrationNumber);
                } else {
                    proceedToRegNoFlow(regNoTrimmed, registrationNumber);
                }
            })
                .catch((error) => {
                    const { status = "" } = error;
                    if (status === HTTP_CODES.RESOURCE_ALREADY_EXIST) {
                        setIsDuplicateAppointment(true);
                        setIsLoading(false);
                    }
                    setIsLoading(false);
                });

            window.scrollTo(0, 0);

        } else {
            setIsNotCarReg(true);
            setIsValidRegistrationNumber(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const onInputChangeHandler = ({target: {value}}) => {
        const regexp = /[^a-z0-9]/gi;
        const sanitizedValue = (value || "").replace(regexp, "").toUpperCase();
        setIsDuplicateAppointment(false);
        setRegistrationNumber(sanitizedValue);
    };

    // eslint-disable-next-line no-unused-vars
    return (
        <React.Fragment>
            {
                isRevamped &&
                <div styleName={"styles.carNumber"}>
                    <InputRegNo
                        inputRef={registrationInputRef}
                        value =  {registrationNumber}
                        onChange = {handleOnChange}
                        validator={registrationNumberValidator}
                        onBlurCallback={onBlurCallBack}
                        onFocusCallback={onFocusCallback}
                        errorMessage={"Please enter a valid car number"}
                        isFromRegHomePage={!disableRouting}
                        isError={isNotCarReg}
                        autoCapitalize="characters"
                        isPlaceholderTypingAnimation={!isLoggedIn}
                    />
                    <button
                        onClick = {onClickHandler}
                        disabled={!isValidRegistrationNumber && disableBtnOnInvalidInput}
                    >
                        <ArrowIcon />
                    </button>
                </div>
            }
            {
                !isRevamped &&
                <React.Fragment>
                    {
                        isDlsCompliant ?
                            <Input
                                customErrorMessage={isDuplicateAppointment ? "Appointment already exists" : "Please enter a valid car number"}
                                type="text"
                                prefix={<img width={"41px"} height={"58px"} src={isElitePage ? EliteRegNo : RegNoPrefix} alt="Reg no" />}
                                onChange={onInputChangeHandler}
                                value={formatInputValue({ inputValue: registrationNumber })}
                                onBlur={onBlurCallBack}
                                isError={isNotCarReg || isDuplicateAppointment}
                                placeholder="DL 01 AB12XX"
                                validator={registrationNumberValidator}
                            /> :
                            <div styleName={"styles.carField"}>
                                <InputRegNo
                                    inputRef={registrationInputRef}
                                    value =  {registrationNumber}
                                    onChange = {handleOnChange}
                                    validator={registrationNumberValidator}
                                    onBlurCallback={onBlurCallBack}
                                    onFocusCallback={onFocusCallback}
                                    errorMessage={isDuplicateAppointment ? "Appointment already exists" : "Please enter a valid car number"}
                                    isFromRegHomePage={!disableRouting}
                                    isError={isNotCarReg || isDuplicateAppointment}
                                    autoCapitalize="characters"
                                    isPlaceholderTypingAnimation={!isLoggedIn}
                                    customErrorText={isDuplicateAppointment ? "Appointment already exists" : "Please enter a valid car number"}
                                    isElitePage={isElitePage}
                                />
                            </div>
                    }
                    {
                        isAlliancReferraleOfferActive &&
                        <div>
                            <label styleName={"styles.emailHeading"}>Enter RA email address</label>
                            <InputText
                                type="email"
                                placeholder="Enter RA email address"
                                value={email}
                                id="email"
                                validator={emailValidator}
                                onChange={handleEmailChange}
                                showErrorOnFocus={true}
                                errorMessage="Please enter a valid email address"
                            />
                        </div>
                    }
                    <div styleName= {isElitePage ? "styles.eliteButton" : ""}>
                        <Button
                            label={ctaText || "Get instant car price"}
                            isLoading={isLoading}
                            onClick = {onClickHandler}
                            disabled={!isValidRegistrationNumber && disableBtnOnInvalidInput}
                            size="large"
                        />
                    </div>
                </React.Fragment>
            }

            {isFormVisible && isAllStepFill && <RegCarDetailsPopup close={closeModal} confirm={submitLead} /> }
        </React.Fragment>
    );
};

CarRegistrationNumber.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    isMarketing: PropTypes.bool,
    registrationNo: PropTypes.string,
    leadData: PropTypes.object,
    isFromSellOnlineFlow: PropTypes.bool,
    setRegistrationNoConnect: PropTypes.func,
    getVehicleDetailConnect: PropTypes.func,
    setDataConnect: PropTypes.func,
    fetchYearListConnect: PropTypes.func,
    setStepConnect: PropTypes.func,
    setFuelTypeConnect: PropTypes.func,
    setOwnerNameConnect: PropTypes.func,
    setTransmissionTypeConnect: PropTypes.func,
    setVariantActiveScreenConnect: PropTypes.func,
    history: PropTypes.object,
    setRTOConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func,
    setAllStepFilledConnect: PropTypes.func,
    setUserCarRgistrationNoConnect: PropTypes.func,
    resetLeadFormDataConnect: PropTypes.func,
    setFocusBlurRegBoxConnect: PropTypes.func,
    fetchYearsBasedOnMakeIdConnect: PropTypes.func,
    setDsaVariantsConnect: PropTypes.func,
    setAllDetailFetchedCorrectlyConnect: PropTypes.func,
    setAnsweredQuestionsConnect: PropTypes.func,
    setNameConnect: PropTypes.func,
    disableBtnOnInvalidInput: PropTypes.bool,
    disableRouting: PropTypes.bool,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    isRevamped: PropTypes.bool,
    userCarRegistrationNo: PropTypes.string,
    sellerHomeRegistationNumberExperiment: PropTypes.string,
    registrationInputRef: PropTypes.any,
    customRouting: PropTypes.bool,
    setHypothecationConnect: PropTypes.func,
    changeClass: PropTypes.bool,
    isNewHomePage: PropTypes.bool,
    sellerOnFocus: PropTypes.func,
    sellerOnClickCta: PropTypes.func,
    sellerOnBlur: PropTypes.func,
    activateFirstStepConnect: PropTypes.func,
    setShowWidgetConnect: PropTypes.func,
    ctaText: PropTypes.string,
    leadSource: PropTypes.string,
    checkForDuplicateAppointmentConnect: PropTypes.func,
    setDataFaliureConnect: PropTypes.func,
    setIsRepeatInspectionConnect: PropTypes.func,
    isRepeatUser: PropTypes.bool,
    match: PropTypes.object,
    isFormVisible: PropTypes.bool,
    isDlsCompliant: PropTypes.bool,
    secureToken: PropTypes.string,
    isElitePage: PropTypes.bool

};

export default CarRegistrationNumber;
